<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-key"></i> Sessions
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Token</th>
              <th>Device ID</th>
              <th>IP</th>
              <th>Platform</th>
              <th>OS</th>
              <th>Store</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>
            @for (session of sessions; track session.sessionToken; let i = $index) {
              <tr>
                <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                <td>{{ session.createTimeTimestamp !== 0 ? dateService.getDateFromatted(session.createTimeTimestamp) : '-' }}</td>
                <td>
                  <small class="text-muted" style="cursor:pointer; word-break:break-all" (click)="toggleToken(i)">
                    @if (expandedTokens.has(i)) {
                      {{ session.sessionToken }}
                    } @else {
                      {{ session.sessionToken | slice:0:40 }}{{ session.sessionToken.length > 40 ? '...' : '' }}
                    }
                  </small>
                </td>
                <td><small class="text-muted">{{ session.deviceId || '-' }}</small></td>
                <td>{{ session.ipAddress || '-' }}</td>
                <td>{{ session.platform || '-' }}</td>
                <td>{{ session.deviceOs || '-' }}</td>
                <td>{{ session.store || '-' }}</td>
                <td>{{ session.appVersion || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + sessions.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="sessions.length < resultsPerPage">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="sessions.length < resultsPerPage">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
